<template>
  <div class="common-panel">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="panel-content">
      <!-- 选项 -->
      <div class="panel-content-options">
        <div class="question-options-item" v-for="option in currItemOptions" :key="option.index">
          <div class="item-key">{{ option.key }}</div>
          <div class="item-content">
            <img :src="baseUrl + option.content + '?width=300'" alt="" />
          </div>
        </div>
      </div>
      <!-- 套题 -->
      <div class="panel-content-details">
        <div class="question-item" v-for="(item, itemIndex) in filterQuestionList" :key="itemIndex">
          <div class="question-item-flex">
            <div class="question-item-stem">
              <div class="stem-index">{{ item.is_example ? $t('hsk_example') : item.index }}.</div>
              <div class="stem-content">
                <img
                  v-show="!isExamMode && (item.playStatus == 'play' || !item.playStatus)"
                  @click="clickPlayVoice(item, true)"
                  :src="iconPlay('play')"
                  alt=""
                />
                <!-- <CricleTimer
                  v-show="item.playStatus == 'pause'"
                  v-if="middleTime"
                  :start-time="startTime"
                  :middle-time="middleTime"
                  :step="-1"
                  :thresholds="[
                    {
                      color: '#f6f8fa',
                      threshold: startTime > 60 ? 0.01 : 0.1,
                    },
                  ]"
                  :width="40"
                  :height="40"
                >
                  <img slot="content" :src="iconPlay('playHsk')" alt="" />
                </CricleTimer> -->
                <img
                  v-if="!isExamMode && item.playStatus == 'pause'"
                  @click="clickPauseVoice(item)"
                  :src="iconPlay('pause')"
                  alt=""
                />
              </div>
            </div>
            <div class="question-item-options">
              <div
                v-for="option in item.answers"
                :key="`${item.index}_${option.index}`"
                :class="[
                  'question-item-options-item',
                  {
                    selected: option.selected || (item.is_example && option.correct),
                    success: !isExamMode && option.correct,
                    error: !isExamMode && option.selected && !option.correct,
                  },
                ]"
                :data-correct="option.correct ? 1 : 0"
                @click="clickQuestionChoice($event, item, option, itemIndex)"
              >
                {{ String.fromCharCode(64 + parseInt(option.index)) }}
              </div>
            </div>
          </div>

          <div
            class="panel-content-result result-correct"
            v-if="
              !isExamMode && !currItem.is_example && item.myAnswerText == item.successAnswerText
            "
          >
            <p class="correct-tips">
              {{ $t('textbook_chioce_word_text_correct_tip') }}
            </p>
            <div class="correct-box" v-if="item.analysisText">
              <p class="correct-box-title" v-if="item.audioText">
                {{ $t('hsk_audio_text') }}
              </p>
              <p class="correct-box-answer" v-if="item.audioText">
                {{ item.audioText }}
              </p>
              <div v-show="analysisText">
                <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
                <p class="correct-box-answer">
                  {{ item.analysisText }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="panel-content-result result-error"
            v-if="
              !isExamMode && !currItem.is_example && item.myAnswerText != item.successAnswerText
            "
          >
            <p class="error-tips">
              {{ $t('textbook_chioce_word_text_error_tip') }}
            </p>
            <div class="result-show">
              <div class="your-answer">{{ $t('hsk_your_answer') }}{{ item.myAnswerText }}</div>
              <p class="correct-answer">
                {{ $t('hsk_correct_answer') }}{{ item.successAnswerText }}
              </p>
            </div>
            <div class="correct-box">
              <p class="correct-box-title" v-if="item.audioText">
                {{ $t('hsk_audio_text') }}
              </p>
              <p class="correct-box-answer" v-if="item.audioText">
                {{ item.audioText }}
              </p>
              <div v-show="item.analysisText">
                <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
                <p class="correct-box-answer">
                  {{ item.analysisText }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PhoneticText from '@/components/ui/phoneticText'
// import CricleTimer from "@/components/ui/CricleTimer/index.vue";
import QuestionDescription from '@/components/hsk/questionDescription'
import { VOICE_EXTEND_TIME } from '@/config'

export default {
  components: {
    // PhoneticText,
    // CricleTimer,
    QuestionDescription,
  },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 当前试题正确答案
      currCorrectAnswer: [1, 2, 3],
      // 是否已提交
      isSubmit: false,
      // 是否页面事件禁用
      isDisabled: false,
      icons: {
        play: require('@/assets/images/btn_play_hsk.png'),
        pause: require('@/assets/images/btn_pause_hsk.png'),
        playHsk: require('@/assets/images/play_hsk.png'),
      },
      changeBtn: false,
      startTime: 0,
      middleTime: 0,

      // playVoiceTime: '',
    }
  },
  computed: {
    currItemOptions() {
      let array = []
      array = this.currItem.questions[0].answers.map((item, index) => {
        return {
          index: item.index,
          key: String.fromCharCode(64 + parseInt(item.index)),
          content: item.content,
        }
      })
      return array
    },
    computedExampleNum() {
      return this.currItem.questions.filter((item) => item.is_example).length
    },
    //初始黑色
    textBlackStyles() {
      return {
        // 拼音文本初始颜色
        originPinyinColor: '#3F4651',
        // 拼音文本字体大小
        pinyinFontSize: '10px',
        // 拼音文本 行高
        pinyinLineHeight: '14px',
        // 汉字文本初始颜色
        originHzColor: '#3E4651',
        // 拼音文本字体大小
        hzFontSize: '15px',
        // 汉字文本 行高
        hzLineHeight: '15px',
        // 行文 间距(下方间距)
        writingSpacing: '5px',
        // 分词间距
        wordSpacing: '10px',
      }
    },
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    filterQuestionList() {
      let questionsList = this.currItem.questions
      //根据当前语言显示分析
      questionsList
        .filter(function (item) {
          return !item.is_example
        })
        .map((item, index) => {
          console.log(this.language)
          item.analysisText =
            (item.analysis && item.analysis[this.language]) ||
            (item.analysis && item.analysis['zh']) ||
            ''
          item.audioText = item.content_sentence
          if (this.currItem.answer && this.currItem.answer.length > 0 && !this.changeBtn) {
            for (let i = 0; i < item.answers.length; i++) {
              if (item.answers[i].index == this.currItem.answer[index]) {
                item.answers[i].selected = true
                item.myAnswerText = item.answers[i].flag
              } else {
                item.answers[i].selected = false
              }
              if (item.answers[i].correct) {
                item.successAnswerText = item.answers[i].flag
              }
            }
          }
        })
      this.changeBtn = false
      return questionsList
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    ansProgressStatus: {
      type: Number,
      required: false,
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  watch: {
    ansProgressStatus: {
      handler(val) {
        if (val == 2) {
          this.middleTime = 0
        }
      },
    },
  },
  mounted() {
    this.startTime = this.$player.totalTime
    this.middleTime = this.$player.lastPlayTime
    if (this.ansProgressStatus == 1) {
      this.resetPlayStatus(this.currItem, 'pause', true)
    } else {
      this.middleTime = 0
    }
  },
  methods: {
    // 小题选项点击事件
    clickQuestionChoice(event, question, option, index) {
      // this.stopAllVoice()
      if (question.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      const isCorrect = parseInt(event.currentTarget.dataset.correct)
      let questions = this.currItem.questions.map((item) => {
        // 更新重选的答案
        this.$set(this.currItem.answer, index - this.computedExampleNum, option.index.toString())
        if (item.index === question.index) {
          // item.playStatus = 'play'
          let questionTemp = {
            ...item,
            ansId: option.index, // 学生作答
            isFinished: true, // 标识已作答
            isCorrect, // 标识是否作答成功
          }
          questionTemp.answers = questionTemp.answers.map((item1) => {
            if (item1.index === option.index) {
              return {
                ...item1,
                selected: true,
              }
            } else {
              return {
                ...item1,
                selected: false,
              }
            }
          })

          return questionTemp
        } else {
          return {
            ...item,
          }
        }
      })

      this.changeBtn = true
      this.currItem.questions = questions
      Object.assign(this.currItem.questions, questions)

      // 作答的对象
      let ansObj = {
        questionId: question.index,
        answer: option.index.toString(),
        judge: isCorrect,
        scores: isCorrect == 1 ? question.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      }

      // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
    //播放
    playVoice(question, isTryAgain) {
      // 播放前重新渲染下组件
      this.middleTime = 0
      this.resetPlayStatus(question, 'pause')
      let audioPath = this.baseUrl + question.content
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.resetPlayStatus(question, 'play')
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.playVoice(question, true)
              layer.close(index)
            },
            btn2: (index) => {
              _this.HSKVoice('HSKVoice', Date.parse(new Date()))
              layer.close(index)
            },
          })
        } else {
          setTimeout(() => {
            let partData = this.$store.state.simulation.currentPart
            console.log('当前听力组件 setChoosePicByVoiceSimulation ', partData)
            if (partData.part == 'listen' && !partData.isPaused)
              _this.HSKVoice('HSKVoice', Date.parse(new Date()))
          }, VOICE_EXTEND_TIME * 1000)
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
        console.log(this.startTime)
      }
    },
    //点击播放
    clickPlayVoice(question, status) {
      if (this.isExamMode && status) return
      this.resetPlayStatus(question, 'pause')
      let audioPath = this.baseUrl + question.content
      this.$player.play(audioPath)
      this.$player.onended = () => {
        this.resetPlayStatus(question, 'play')
      }
    },
    //点击暂停
    clickPauseVoice(question) {
      this.$player.pause()
      this.resetPlayStatus(question, 'play')
    },
    //根据状态显示播放/暂停按钮
    iconPlay(playType) {
      return this.icons[playType]
    },
    //重置播放状态
    resetPlayStatus(question, status, isclickStatus) {
      let questions = this.currItem.questions.map((item) => {
        console.log(this.currItem)
        let finallyStatus
        if (isclickStatus) {
          finallyStatus =
            item.index === question.currentPlayIndex &&
            this.currItem.bigIndex == question.currentPlayBigIndex
        } else {
          finallyStatus = item.index === question.index
        }
        if (finallyStatus) {
          item.playStatus = status
          console.log(item.playStatus)
          return item
        } else {
          item.playStatus = 'play'
          return {
            ...item,
          }
        }
      })
      this.currItem.questions = questions
      console.log(questions)
    },
    //存在作答的小题时，自动播放未作答的小题音频
    autoPlay(obj) {
      this.playVoice(obj)
    },
    //停止全部音频，图标都恢复原来的未播放状态
    stopAllVoice() {
      this.currItem.questions.forEach((question) => {
        question.playStatus = 'play'
      })
      this.$player.stop()
    },
  },
}
</script>

<style lang="scss" scoped>
.common-panel {
  position: relative;
  padding-top: 30px;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .panel-content {
    min-height: 540px;

    // 选项列表
    &-options {
      padding: 30px 30px 0px 30px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .question-options-item {
        width: 195px;
        height: 110px;
        margin-bottom: 20px;
        margin-right: 30px;
        border-radius: 5px;
        position: relative;

        .item-key {
          width: 46px;
          height: 27px;
          line-height: 27px;
          text-align: center;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 4px 0px 4px 0px;
          position: absolute;
          top: 0px;
          left: 0px;
        }
        .item-content {
          img {
            width: 195px;
            height: 110px;
            border-radius: 5px;
            object-fit: contain;
          }
        }
      }
    }

    // 套题详情
    &-details {
      padding: 0 30px;

      .question-item {
        padding: 20px 0;
        border-top: 1px solid #f2f3f7;
        &-flex {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        &-stem {
          display: flex;
          flex-direction: row;
          align-items: center;

          .stem-index {
            margin-right: 10px;
            color: #c4c9d3;
          }
          .stem-content {
            img {
              width: 40px;
              height: 40px;
              cursor: pointer;
            }
          }
        }
        &-options {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          &-item {
            cursor: pointer;
            width: 42px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            background-color: rgba(242, 243, 247, 1);
            border-radius: 2px;
            margin-right: 20px;
            color: rgba(57, 61, 70, 1);
            font-size: 14px;

            &.selected {
              border: 2px solid #faae56;
              background: #ffffff;
            }
            &.success {
              background: #ffffff; // 设置白色背景
              border: 1px solid rgba(9, 203, 160, 1);
              color: #09cba0;
            }
            &.error {
              border: 1px solid #fc5a5a;
              color: #fc5a5a;
              background: #ffffff;
            }
          }
        }
      }
    }

    // 选词填空选项列表
    &-answers {
      margin-top: 30px;
      .list-answers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .item-answer {
        cursor: pointer;
        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;

        width: 380px;
        height: 58px;
        line-height: 58px;
        font-size: 18px;
        margin-top: 20px;

        color: rgba(63, 70, 81, 1);
        background: rgba(242, 243, 247, 1);
        border-radius: 5px;
        box-sizing: border-box;

        .text {
          overflow: hidden;
          text-overflow: ellipsis;

          ::v-deep.pht_single {
            margin-bottom: 10px !important;
          }
        }

        &:after {
          position: absolute;
          content: '';
          width: 16px;
          height: 16px;
          right: -24px;
          top: 50%;
          transform: translateY(-50%);
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: cover;
        }

        &.success {
          background: #ffffff; // 设置白色背景
          border: 1px solid rgba(9, 203, 160, 1);
          color: #09cba0;
        }

        &.error {
          background: #ffffff;
          border: 1px solid #fc5a5a;
          color: #fc5a5a;
        }
      }
    }

    // 结果
    &-result {
      padding-top: 20px;

      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
